var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.632 24a1 1 0 0 0 1 1h2.737a1 1 0 0 0 1-1v-5.632H24a1 1 0 0 0 1-1v-2.737a1 1 0 0 0-1-1h-5.63V8a1 1 0 0 0-1-1h-2.738a1 1 0 0 0-1 1v5.631H8a1 1 0 0 0-1 1v2.737a1 1 0 0 0 1 1h5.632z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16m-1.368-7a1 1 0 0 1-1-1v-5.632H8a1 1 0 0 1-1-1v-2.737a1 1 0 0 1 1-1h5.632V8a1 1 0 0 1 1-1h2.737a1 1 0 0 1 1 1v5.631H24a1 1 0 0 1 1 1v2.737a1 1 0 0 1-1 1h-5.63V24a1 1 0 0 1-1 1z",
    clipRule: "evenodd",
    opacity: 0.4
  })));
};
export default SvgPlus;